/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для спойлера.
   */
  app.SpoilerContestsView = app.View.extend({
    el: '[data-spoiler]',
    
    events: {
      'click': 'toggle_spoiler'
    },
    
    run: function () {
      this.$el.addClass('link_pseudo').removeAttr('href');
      $('div.hide').css('display', 'none');
    },
    toggle_spoiler: function () {
      var toggleClassName = this.$el.data('spoiler');
      $('div' + toggleClassName).toggle('slow');
    }
  });
})(jQuery);

}.call(window));